// extracted by mini-css-extract-plugin
export default {"component":"ChangeLocaleDropdown_component__Hg9Q-"};